import styled from "styled-components"
import StatBox from "./StatBox"
import { FC } from "react"
import { divisionLogos } from "../../../content-options/division-logos"
import { useLeague } from "../../../context/useLeague"
import placeholderImage from "../../../images/common/vgc-logo.png"

const MatchDetailsPitch: FC = () => {
  const { league, upcomingFixtures } = useLeague()

  // Getting division logo
  function getDivisionLogo(division: number): string | null {
    return divisionLogosExtended[division.toString()] || null
  }

  const divisionLogosExtended: { [key: string]: string } = divisionLogos

  return (
    <Wrapper>
      {league && upcomingFixtures[0] ? (
        <Container>
          <StatBox title={"DATE"} component={upcomingFixtures[0].date} />
          <StatBox title={"TIME"} component={upcomingFixtures[0].time} />
          <StatBox
            title={"VS"}
            component={<Img src={upcomingFixtures[0].image || placeholderImage} />}
          />
          <StatBox
            title={"LEAGUE"}
            component={<Img src={getDivisionLogo(league.division) || placeholderImage} />}
          />
        </Container>
      ) : null}
    </Wrapper>
  )
}
export default MatchDetailsPitch
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 0 0.6rem 0;
`
const Container = styled.div`
  width: 100%;
  display: flex;
  background: linear-gradient(135deg, #000000 0%, #001a4d 40%, #0d47a1 50%, #001a4d 60%, #000000 100%);
  border-radius: 8px;
  border: 0.5px solid gray;
  padding: 0 0.5rem;
  box-shadow: 0px 1px 5px rgb(38, 38, 38);
`
const Img = styled.img`
  height: 70%;
`
